import type {ClientCompanyBillingInfoParam, ClientCompanyBillingInfoResource} from '@api';

export function clientCompanyInfosInitData(
    clientCompanyBillingInformation: ClientCompanyBillingInfoResource,
): Pick<ClientCompanyBillingInfoParam, 'billingContact' | 'otherBillingContacts'> {
    const billingInfo = clientCompanyBillingInformation || {};

    return {
        billingContact: billingInfo.billingContact || '',
        otherBillingContacts: billingInfo.otherBillingContacts ?? [],
    };
}
